// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-list {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
}

.list-controls {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px;
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
  align-items: center;
}

.search-input {
  flex: 1 1;
  padding: 6px 8px;
  background-color: #1e293b;
  border: 1px solid #475569;
  border-radius: 4px;
  color: #f1f5f9;
  font-size: 12px;
  min-width: 0;
}

.search-input::placeholder {
  color: #64748b;
}

.sort-dropdown {
  position: relative;
}

.sort-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  background-color: #1e293b;
  border: 1px solid #475569;
  border-radius: 4px;
  color: #cbd5e1;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.sort-button:hover {
  background-color: #334155;
  border-color: #64748b;
  color: #f1f5f9;
}

.sort-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background-color: #1e293b;
  border: 1px solid #475569;
  border-radius: 4px;
  min-width: 140px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  z-index: 50;
}

.sort-option {
  display: block;
  width: 100%;
  padding: 8px 12px;
  background-color: transparent;
  border: none;
  color: #cbd5e1;
  text-align: left;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.sort-option:hover {
  background-color: #334155;
  color: #f1f5f9;
}

.sort-option.active {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.no-servers {
  padding: 20px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}

.server-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.server-item:hover {
  background-color: #1e293b;
  border-color: #475569;
}

.server-item.active {
  background-color: #1e40af;
  border-color: #3b82f6;
}

.server-info {
  flex: 1 1;
  min-width: 0;
}

.server-info h3 {
  margin: 0 0 6px 0;
  font-size: 14px;
  font-weight: 600;
  color: #f1f5f9;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.server-port {
  font-size: 11px;
  color: #94a3b8;
  margin-bottom: 6px;
}

.badges-container {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.running {
  background-color: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.status-badge.stopped {
  background-color: rgba(107, 114, 128, 0.1);
  color: #9ca3af;
}

.status-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.scheduled-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: rgba(168, 85, 247, 0.1);
  border-radius: 4px;
  font-size: 11px;
  color: #c084fc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.players-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: rgba(59, 130, 246, 0.1);
  border-radius: 4px;
  font-size: 11px;
  color: #3b82f6;
}

.scheduled-badge svg,
.players-badge svg {
  flex-shrink: 0;
}

.status-badge.running .status-dot {
  background-color: #22c55e;
  animation: pulse 2s infinite;
}

.status-badge.stopped .status-dot {
  background-color: #9ca3af;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.server-actions {
  display: flex;
  gap: 8px;
  margin-left: 8px;
}

.server-list .action-button {
  padding: 6px;
  background-color: transparent;
  border: 1px solid #475569;
  border-radius: 4px;
  color: #cbd5e1;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.server-list .action-button:hover {
  border-color: #64748b;
  color: #f1f5f9;
}

.server-list .action-button.launch:hover {
  background-color: rgba(34, 197, 94, 0.1);
  border-color: #22c55e;
  color: #22c55e;
}

.server-list .action-button.stop:hover {
  background-color: rgba(239, 68, 68, 0.1);
  border-color: #ef4444;
  color: #ef4444;
}

.server-list .action-button.config:hover {
  background-color: rgba(59, 130, 246, 0.1);
  border-color: #3b82f6;
  color: #3b82f6;
}

.server-list .action-button.delete:hover {
  background-color: rgba(239, 68, 68, 0.1);
  border-color: #ef4444;
  color: #ef4444;
}

.server-list .action-button.broadcast {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #cbd5e1;
}

.server-list .action-button.broadcast:hover {
  background-color: rgba(239, 68, 68, 0.1);
  border-color: #ef4444;
  color: #ef4444;
}

/* Path Modal */
.path-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.path-modal {
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  max-width: 500px;
  width: 90%;
}

.path-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.path-modal-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #f1f5f9;
}

.path-modal-close {
  background: none;
  border: none;
  color: #cbd5e1;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.path-modal-close:hover {
  color: #f1f5f9;
}

.path-modal-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.path-text {
  margin: 0;
  font-size: 12px;
  font-family: 'Monaco', 'Courier New', monospace;
  color: #cbd5e1;
  background-color: #0f172a;
  padding: 8px;
  border-radius: 4px;
  word-break: break-all;
  border: 1px solid #334155;
}

.copy-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: background-color 0.2s;
}

.copy-button:hover {
  background-color: #2563eb;
}
`, "",{"version":3,"sources":["webpack://./src/components/ServerList.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+CAA+C;EAC/C,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".server-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding: 8px;\r\n}\r\n\r\n.list-controls {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n  padding: 8px;\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  padding: 6px 8px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 4px;\r\n  color: #f1f5f9;\r\n  font-size: 12px;\r\n  min-width: 0;\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: #64748b;\r\n}\r\n\r\n.sort-dropdown {\r\n  position: relative;\r\n}\r\n\r\n.sort-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 6px 8px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 4px;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sort-button:hover {\r\n  background-color: #334155;\r\n  border-color: #64748b;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.sort-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  margin-top: 4px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 4px;\r\n  min-width: 140px;\r\n  overflow: hidden;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\r\n  z-index: 50;\r\n}\r\n\r\n.sort-option {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  background-color: transparent;\r\n  border: none;\r\n  color: #cbd5e1;\r\n  text-align: left;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.sort-option:hover {\r\n  background-color: #334155;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.sort-option.active {\r\n  background-color: rgba(59, 130, 246, 0.2);\r\n  color: #3b82f6;\r\n}\r\n\r\n.no-servers {\r\n  padding: 20px;\r\n  text-align: center;\r\n  color: #64748b;\r\n  font-size: 14px;\r\n}\r\n\r\n.server-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px;\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.server-item:hover {\r\n  background-color: #1e293b;\r\n  border-color: #475569;\r\n}\r\n\r\n.server-item.active {\r\n  background-color: #1e40af;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.server-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.server-info h3 {\r\n  margin: 0 0 6px 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.server-port {\r\n  font-size: 11px;\r\n  color: #94a3b8;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.badges-container {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.running {\r\n  background-color: rgba(34, 197, 94, 0.1);\r\n  color: #22c55e;\r\n}\r\n\r\n.status-badge.stopped {\r\n  background-color: rgba(107, 114, 128, 0.1);\r\n  color: #9ca3af;\r\n}\r\n\r\n.status-dot {\r\n  display: inline-block;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.scheduled-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  background-color: rgba(168, 85, 247, 0.1);\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  color: #c084fc;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.players-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 4px 8px;\r\n  background-color: rgba(59, 130, 246, 0.1);\r\n  border-radius: 4px;\r\n  font-size: 11px;\r\n  color: #3b82f6;\r\n}\r\n\r\n.scheduled-badge svg,\r\n.players-badge svg {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.status-badge.running .status-dot {\r\n  background-color: #22c55e;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.status-badge.stopped .status-dot {\r\n  background-color: #9ca3af;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n}\r\n\r\n.server-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-left: 8px;\r\n}\r\n\r\n.server-list .action-button {\r\n  padding: 6px;\r\n  background-color: transparent;\r\n  border: 1px solid #475569;\r\n  border-radius: 4px;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.server-list .action-button:hover {\r\n  border-color: #64748b;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.server-list .action-button.launch:hover {\r\n  background-color: rgba(34, 197, 94, 0.1);\r\n  border-color: #22c55e;\r\n  color: #22c55e;\r\n}\r\n\r\n.server-list .action-button.stop:hover {\r\n  background-color: rgba(239, 68, 68, 0.1);\r\n  border-color: #ef4444;\r\n  color: #ef4444;\r\n}\r\n\r\n.server-list .action-button.config:hover {\r\n  background-color: rgba(59, 130, 246, 0.1);\r\n  border-color: #3b82f6;\r\n  color: #3b82f6;\r\n}\r\n\r\n.server-list .action-button.delete:hover {\r\n  background-color: rgba(239, 68, 68, 0.1);\r\n  border-color: #ef4444;\r\n  color: #ef4444;\r\n}\r\n\r\n.server-list .action-button.broadcast {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-decoration: none;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.server-list .action-button.broadcast:hover {\r\n  background-color: rgba(239, 68, 68, 0.1);\r\n  border-color: #ef4444;\r\n  color: #ef4444;\r\n}\r\n\r\n/* Path Modal */\r\n.path-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 999;\r\n}\r\n\r\n.path-modal {\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\r\n  max-width: 500px;\r\n  width: 90%;\r\n}\r\n\r\n.path-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.path-modal-header h4 {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.path-modal-close {\r\n  background: none;\r\n  border: none;\r\n  color: #cbd5e1;\r\n  cursor: pointer;\r\n  padding: 2px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.path-modal-close:hover {\r\n  color: #f1f5f9;\r\n}\r\n\r\n.path-modal-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.path-text {\r\n  margin: 0;\r\n  font-size: 12px;\r\n  font-family: 'Monaco', 'Courier New', monospace;\r\n  color: #cbd5e1;\r\n  background-color: #0f172a;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  word-break: break-all;\r\n  border: 1px solid #334155;\r\n}\r\n\r\n.copy-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 8px 12px;\r\n  background-color: #3b82f6;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.copy-button:hover {\r\n  background-color: #2563eb;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
